import angular from "angular";

angular
	.module('app')
	.component('groupAutomatizationSettingsNotFound', {
		template: require('./group-automatization-settings-not-found.html'),
        controller: ['$http', 'Notifier', controller],
        bindings: {
            group: '<',
            course: '<',
        }
    });

function controller($http, Notifier) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
        //
    };
}
